import React, { useState } from 'react';
import Header from '../organisms/Header';
import ContactModal from '../organisms/ContactModal';
import { useTranslation } from 'react-i18next';

const DetailPageTemplate = ({
  children,
  serviceName = '',
  onContactSubmit
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    service: serviceName
  });

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (onContactSubmit) {
      onContactSubmit(formData);
    } else {
      console.log('Form submitted:', formData);
      alert(t('contact.thankYou'));
    }
    setIsModalOpen(false);
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: '',
      service: serviceName
    });
  };

  const handleContactClick = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white">
      <Header onContactClick={handleContactClick} />

      {children({
        onContactClick: handleContactClick,
        formData,
        setFormData
      })}

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={serviceName ? `${serviceName}${t('common.inquiry')}` : t('contact.title')}
        serviceName={serviceName}
        formData={formData}
        onFormChange={setFormData}
        onSubmit={handleFormSubmit}
      />
    </div>
  );
};

export default DetailPageTemplate;
